import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import _ from 'lodash';

import type { LogBookDataV2 } from 'commons/modules/service/log-processV2';

import type { RootState } from './configureStore';

const initialState: LogBookDataV2[] = [];

export const slice = createSlice({
  name: 'files',
  initialState,
  reducers: {
    fileChecked: (
      files: LogBookDataV2[],
      action: PayloadAction<LogBookDataV2>,
    ) => {
      files.push(action.payload);
    },

    fileUnchecked: (
      files: LogBookDataV2[],
      action: PayloadAction<LogBookDataV2>,
    ) => {
      _.remove(files, (file) => file.folio === action.payload.folio);
    },
    filesResetted: () => initialState,
  },
});

export const { fileChecked, fileUnchecked, filesResetted } = slice.actions;
export default slice.reducer;

// Selectors
export const getFiles = (state: RootState) => state.entities.files;
